import { isEmpty } from "lodash";
import { useCallback } from "react";
import { SngpcStorageKeys, useSngpcStorage } from ".";
import { MenuProviderModel } from "../providers/menu-principal-provider/menu-principal-provider-model";

export function useMenuStorage() {
    const { getRegistro, setRegistro, delRegistro } = useSngpcStorage();

    const get = useCallback((): MenuProviderModel => {
        let menu = getRegistro(SngpcStorageKeys.ConfiguracoesMenu, false) as MenuProviderModel;
        if (isEmpty(menu)) {
            menu = {
                situacao: "Fechado",
                modelo: "Completo"
            };
            setRegistro(SngpcStorageKeys.ConfiguracoesMenu, menu, false);
        }
        return menu;
    }, [getRegistro, setRegistro]);

    const persist = useCallback((model: MenuProviderModel) => {
        if (model === undefined) {
            delRegistro(SngpcStorageKeys.ConfiguracoesMenu, false);
        } else {
            setRegistro(SngpcStorageKeys.ConfiguracoesMenu, model, false);
        }
    }, [delRegistro, setRegistro]);

    return {
        get,
        persist
    };
}
